import { times } from "lodash";
import { MemberCard } from "@circle-react-uikit/SkeletonLoader/skeletons/MemberCard";

export interface SpaceMemberListPageProps {
  count?: number;
}

export const SpaceMemberListPage = ({
  count = 12,
}: SpaceMemberListPageProps) => (
  <div className="space__members-listing">
    {times(count, i => (
      <MemberCard key={i} />
    ))}
  </div>
);
